<ng-template [ngTemplateOutlet]="templateElement" [ngTemplateOutletContext]="{ $implicit: item }"></ng-template>

<ng-template #typ00>
  <span [capHistinfo]="histInfo">
    @if (!item.alt) {
      @if (enableNavigation && item.isNavigierbar && item.geschaeftId && item.geschaeftId.id) {
        <cap-link [openInNewTab]="openInNewTab" [params]="[item.geschaeftId.id]"
                  [target]="navTargets.NAV_GRUNDBUCHGESCHAEFT">
          <ng-template [ngTemplateOutlet]="commonOhneDatum"
                       [ngTemplateOutletContext]="{ $implicit: item }"></ng-template>
        </cap-link>
      } @else {
        <ng-template [ngTemplateOutlet]="commonOhneDatum"></ng-template>
      }
    } @else {
      {{ item | formatBeleg: false }}{{ char }}
    }
    <ng-template [ngTemplateOutlet]="dokulink"></ng-template>
  </span>
</ng-template>

<ng-template #typ01 let-item>
  <span [capHistinfo]="histInfo">
    @if (!item.alt) {
      @if (enableNavigation && item.isNavigierbar && item.geschaeftId && item.geschaeftId.id) {
        <cap-link [openInNewTab]="openInNewTab" [params]="[item.geschaeftId.id]"
                  [target]="navTargets.NAV_GRUNDBUCHGESCHAEFT">
          <ng-template [ngTemplateOutlet]="commonMitDatum"
                       [ngTemplateOutletContext]="{ $implicit: item }"></ng-template>
        </cap-link>
      } @else {
        {{ item | formatBeleg: mitDatum }}{{ char }}
      }
    } @else {
      {{ item | formatBeleg: mitDatum }}{{ char }}
    }
    <ng-template [ngTemplateOutlet]="dokulink"></ng-template>
  </span>
</ng-template>

<ng-template #typ02 let-item>
  <ng-template [ngTemplateOutlet]="onlyDatum"></ng-template>
</ng-template>

<ng-template #typ03 let-item>
  <span [capHistinfo]="histInfo">
    @if (!item.alt) {
      @if (enableNavigation && item.isNavigierbar && item.geschaeftId && item.geschaeftId.id) {
        <cap-link [openInNewTab]="openInNewTab" [params]="[item.geschaeftId.id]"
                  [target]="navTargets.NAV_GRUNDBUCHGESCHAEFT">
          <ng-template [ngTemplateOutlet]="commonMitDatum"
                       [ngTemplateOutletContext]="{ $implicit: item }"></ng-template>
        </cap-link>
      } @else {
        {{ item | formatBeleg: mitDatum }}{{ char }}
      }
    } @else {
      {{ item | formatBeleg: mitDatum }}{{ char }}
    }
    <ng-template [ngTemplateOutlet]="dokulink"></ng-template> </span
  ></ng-template>

<ng-template #commonOhneDatum> {{ item | formatBeleg: false }}{{ char }}</ng-template>

<ng-template #commonMitDatum> {{ item | formatBeleg: mitDatum }}{{ char }}</ng-template>

<ng-template #onlyDatum>
  {{ item.datum | datum }}
</ng-template>

<ng-template #dokulink>
  @if (isCmisGeschaeftConfigured) {
    <cap-cmis [target]="cmisTarget"></cap-cmis>
  }
  @else if (isDokuLinkGeschaeftConfigured) {
    <cap-dokulink [item]="dokulinkItem"></cap-dokulink>
  }
</ng-template>
